import {Map} from 'immutable';
import {supported, features} from 'utils/supported';

export function browserInformation(state = null, action) {
  let nextState = state || Map({
    supported,
    features,
  });

  return nextState;
}



// WEBPACK FOOTER //
// ./app/javascript/reducers/browser.js